import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("sk rounded-md", className)}
      {...props} />
  );
}

export { Skeleton }
